import { AppState } from '@auth0/auth0-react'
import { useSelector } from 'react-redux'

interface LogoProps {
    className?: string
}

const Logo = (props: LogoProps) => {
    const theme = useSelector((state: AppState) => state.theme)
    const src = theme === 'proudNerds' ? '/proud-nerds-logo.png' : '/ajat-logo.png'
    const alt = theme === 'proudNerds' ? 'proud-nerds-logo' : '/ajat-logo'
    const height = theme === 'proudNerds' ? '50' : '32'
    return <img {...props} src={src} alt={alt} height={height} />
}

export default Logo
